import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b8dc090&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/styles/recon-stat.css?vue&type=style&index=0&id=6b8dc090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8dc090",
  null
  
)

export default component.exports